// Angular modules
import { DatePipe }      from '@angular/common';
import { Pipe }          from '@angular/core';
import { PipeTransform } from '@angular/core';

@Pipe({
  name : 'utcDateFormat'
})
export class UtcDateFormatPipe extends DatePipe implements PipeTransform
{
  transform(value: any, format?: string, args?: any): any {
    if (!value) {
      return '';
    }
    if (!format) {
      return super.transform(value, 'yyyy-MM-dd HH:mm:ss', '+000');
    } else {
      return super.transform(value, format, '+000');
    }
  }
}
